import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Checkbox from 'components/ui/Checkbox';
import { StyledCheckboxWrapper } from './PageNavigation.styles';

export const getItemsToShow =
  ({ totalNumberOfPages, selectedPages, itemsPerPage }) =>
  (items) => {
    const numberOfPagesSelected = Object.values(selectedPages).filter((p) => p).length;

    return numberOfPagesSelected === totalNumberOfPages || numberOfPagesSelected === 0
      ? items
      : Object.keys(selectedPages).reduce(
          (acc, index) => (selectedPages[index] ? acc.concat(items.slice(index * itemsPerPage, index * itemsPerPage + itemsPerPage)) : acc),
          []
        );
  };

class PageNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPages: {}
    };
  }

  selectPagesToShow = (index) => {
    const { selectedPages } = this.state;
    const { totalNumberOfPages } = this.props;
    const newSelectedPages = { ...selectedPages, [index]: !selectedPages[index] };
    const newSelectedPagesValues = Object.values(newSelectedPages);
    const allSelected =
      (newSelectedPagesValues.length === totalNumberOfPages && newSelectedPagesValues.every((p) => p === true)) ||
      newSelectedPagesValues.every((p) => !p);

    this.setState({
      selectedPages: allSelected ? {} : newSelectedPages
    });
  };

  selectAllPages = () => {
    this.setState({
      selectedPages: {}
    });
  };

  render() {
    const { children, totalNumberOfPages, itemsPerPage } = this.props;
    const { selectedPages } = this.state;
    const numberOfPagesSelected = Object.values(selectedPages).filter((p) => p).length;

    return (
      <>
        {totalNumberOfPages > 1 && (
          <StyledCheckboxWrapper>
            <div className="page-selector" data-cy="page-selector-all">
              <Checkbox
                onChange={this.selectAllPages}
                checked={numberOfPagesSelected === totalNumberOfPages || numberOfPagesSelected === 0}
                label={<FormattedMessage id="groupBooking.all" />}
              />
            </div>
            {[...Array(totalNumberOfPages)].map((_, i) => {
              const fromPage = i * itemsPerPage + 1;
              const toPage = Math.min(i * itemsPerPage + itemsPerPage, 99);

              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className="page-selector" data-cy={`page-selector-${i}`}>
                  <Checkbox checked={selectedPages[i]} onChange={() => this.selectPagesToShow(i)} label={`${fromPage} - ${toPage}`} />
                </div>
              );
            })}
          </StyledCheckboxWrapper>
        )}
        {children({
          getItemsToShow: getItemsToShow({
            totalNumberOfPages,
            selectedPages,
            itemsPerPage
          })
        })}
      </>
    );
  }
}

PageNavigation.propTypes = {
  children: PropTypes.func,
  totalNumberOfPages: PropTypes.number,
  itemsPerPage: PropTypes.number
};

export default PageNavigation;
